'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _apiMiddleware = require('./api-middleware');

var _apiMiddleware2 = _interopRequireDefault(_apiMiddleware);

var _reducerRegistry = require('./reducer-registry');

var _reducerRegistry2 = _interopRequireDefault(_reducerRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseMiddleware = [];
if (process.env.NODE_ENV !== 'production') {
  var logger = require('redux-logger');
  baseMiddleware.push(logger.createLogger());
}

function configureStore() {
  var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$middleware = _ref.middleware,
      middleware = _ref$middleware === undefined ? [] : _ref$middleware;

  Object.keys(preloadedState).forEach(function (name) {
    _reducerRegistry2.default.register(name, function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : preloadedState[name];
      return state;
    });
  });

  var reducer = (0, _redux.combineReducers)(_reducerRegistry2.default.getReducers());
  var _middleware = middleware.concat(baseMiddleware);
  var store = (0, _redux.createStore)(reducer, _redux.applyMiddleware.apply(undefined, [_reduxThunk2.default, _apiMiddleware2.default].concat(_toConsumableArray(_middleware))));

  // Replace the store's reducer whenever a new reducer is registered.
  _reducerRegistry2.default.setChangeListener(function (reducers) {
    store.replaceReducer((0, _redux.combineReducers)(reducers));
  });

  return store;
}

exports.default = configureStore;